import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import {
  IFareSelectorsState,
  reducer as fareSelectorsReducer,
} from '../reducers/fare-selectors';

import { IFaresState, reducer as faresReducer } from '../reducers/fares';

export const DATA_ACCESS_TICKETS_FARES_FEATURE_KEY = 'ticketsAndFares';
export interface ITicketsAndFareState {
  fareSelectors: IFareSelectorsState;
  fares: IFaresState;
}

export const reducers: ActionReducerMap<ITicketsAndFareState> = {
  fareSelectors: fareSelectorsReducer,
  fares: faresReducer,
};

export const getTicketAndFaresFeatureState =
  createFeatureSelector<ITicketsAndFareState>(
    DATA_ACCESS_TICKETS_FARES_FEATURE_KEY
  );
